module.exports = __webpack_public_path__ + "img/05_full.838d94f7.jpg";